import { useState, useEffect, useRef } from "react";
export default function StatsSection() {
  const ref = useRef<HTMLElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) setVisible(true);
    }, {
      threshold: 0.1
    });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  const stats = [{
    value: "250+",
    label: "Websites Launched"
  }, {
    value: "12000+",
    label: "Leads Generated"
  }, {
    value: "180+",
    label: "Local Businesses Served"
  }, {
    value: "156%",
    label: "Avg. SEO Growth"
  }];
  return <section ref={ref} className="relative overflow-hidden w-full" style={{
    backgroundColor: "oklch(0.129 0.042 264.695)",
    backgroundPosition: "0% 0%",
    backgroundRepeat: "repeat",
    color: "rgb(2, 8, 23)",
    fontFamily: '"DM Sans", sans-serif',
    animation: "none 0s ease 0s 1 normal none running",
    position: "relative",
    overflow: "hidden"
  }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@400;500;600;700&family=DM+Sans:wght@400;500;600;700&display=swap');

        @keyframes fade-in-up {
          0% { opacity: 0; transform: translateY(24px); }
          100% { opacity: 1; transform: translateY(0px); }
        }

        .stat-fade {
          opacity: 0;
          transform: translateY(24px);
          transition: opacity 0.7s ease, transform 0.7s ease;
        }
        .stat-fade.visible {
          opacity: 1;
          transform: translateY(0px);
        }

        .gradient-text {
          background: linear-gradient(90deg, #3B82F6, #8B5CF6);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }
      `}</style>

      <div className="absolute inset-0 w-full h-full" style={{
      backgroundImage: "linear-gradient(rgba(255, 255, 255, 0.1) 1px, rgba(0, 0, 0, 0) 1px), linear-gradient(90deg, rgba(255, 255, 255, 0.1) 1px, rgba(0, 0, 0, 0) 1px)",
      backgroundSize: "60px 60px, 60px 60px",
      backgroundPosition: "0% 0%, 0% 0%",
      backgroundRepeat: "repeat, repeat",
      backgroundBlendMode: "normal, normal",
      color: "rgb(2, 8, 23)",
      fontFamily: '"DM Sans", sans-serif',
      animation: "none 0s ease 0s 1 normal none running",
      position: "absolute",
      opacity: 0.02
    }} />

      <div className="relative z-10 md:py-28" style={{
      paddingTop: "80px",
      paddingBottom: "80px"
    }}>
        <style>{`
          @media (min-width: 768px) {
            .stats-section-inner {
              padding-top: 112px !important;
              padding-bottom: 112px !important;
            }
          }
        `}</style>
        <div className="stats-section-inner relative z-10" style={{
        paddingTop: "80px",
        paddingBottom: "80px",
        marginTop: "-80px",
        marginBottom: "-80px"
      }}>
          <div className="page-container">
            <div className={`flex flex-col items-center stat-fade ${visible ? "visible" : ""}`}>
              <div className="inline-flex items-center gap-2 mb-6" style={{
              backgroundColor: "rgba(13, 21, 38, 0.85)",
              border: "1px solid rgba(255, 255, 255, 0.15)",
              borderRadius: "9999px",
              paddingTop: "6px",
              paddingBottom: "6px",
              paddingLeft: "12px",
              paddingRight: "12px"
            }}>
                <span style={{
                color: "#22D3EE",
                display: "flex",
                alignItems: "center",
                width: "16px",
                height: "16px"
              }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <path d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526"></path>
                    <circle cx="12" cy="8" r="6"></circle>
                  </svg>
                </span>
                <span style={{
                color: "rgba(255,255,255,0.9)",
                fontFamily: '"DM Sans", sans-serif',
                fontSize: "13px",
                fontWeight: 500
              }}>
                  Results That Speak
                </span>
              </div>

              <h2 className="mb-4 text-center" style={{
              color: "rgb(255, 255, 255)",
              fontFamily: "Outfit, sans-serif",
              fontSize: "48px",
              fontWeight: "700",
              lineHeight: "48px",
              letterSpacing: "-1.2px",
              border: "0px solid rgb(226, 232, 240)",
              textAlign: "center",
              animation: "none 0s ease 0s 1 normal none running"
            }}>
                Our Track Record of{" "}
                <span className="gradient-text">Proven</span>
                <br />
                <span className="gradient-text">Success</span>
              </h2>

              <p style={{
              color: "oklch(0.704 0.04 256.788)",
              fontFamily: '"DM Sans", sans-serif',
              fontSize: "18px",
              fontWeight: "400",
              lineHeight: "29.25px",
              border: "0px solid rgb(226, 232, 240)",
              textAlign: "center",
              animation: "none 0s ease 0s 1 normal none running",
              maxWidth: "560px"
            }}>
                Real numbers from real local businesses we&apos;ve helped grow online.
              </p>
            </div>

            <div className={`grid grid-cols-2 md:grid-cols-4 gap-8 mt-12 stat-fade ${visible ? "visible" : ""}`} style={{
            transitionDelay: "200ms"
          }}>
              {stats.map((stat, i) => <div key={i} className="flex flex-col">
                  <span style={{
                color: "rgb(255, 255, 255)",
                fontFamily: "Outfit, sans-serif",
                fontSize: "64px",
                fontWeight: "700",
                lineHeight: "1",
                letterSpacing: "-1px"
              }}>
                    {stat.value}
                  </span>
                  <span className="mt-2" style={{
                color: "oklch(0.704 0.04 256.788)",
                fontFamily: '"DM Sans", sans-serif',
                fontSize: "16px",
                fontWeight: "500",
                lineHeight: "24px",
                border: "0px solid rgb(226, 232, 240)",
                textAlign: "center",
                animation: "none 0s ease 0s 1 normal none running",
                textAlign: "left" as const
              }}>
                    {stat.label}
                  </span>
                </div>)}
            </div>

            <div className={`w-full mt-12 stat-fade ${visible ? "visible" : ""}`} style={{
            height: "1px",
            backgroundColor: "rgba(255,255,255,0.12)",
            transitionDelay: "300ms"
          }} />

            <div className={`flex items-center justify-center gap-2 mt-6 stat-fade ${visible ? "visible" : ""}`} style={{
            transitionDelay: "400ms"
          }}>
              <span style={{
              color: "#FBBF24",
              display: "flex",
              alignItems: "center",
              width: "16px",
              height: "16px"
            }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path>
                </svg>
              </span>
              <p style={{
              color: "oklch(0.704 0.04 256.788)",
              fontFamily: '"DM Sans", sans-serif',
              fontSize: "16px",
              fontWeight: "500",
              lineHeight: "24px",
              border: "0px solid rgb(226, 232, 240)",
              textAlign: "center",
              animation: "none 0s ease 0s 1 normal none running",
              margin: 0
            }}>
                Rated 4.9/5 by local business owners
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}